module.exports = __webpack_public_path__ + "images/5d749a1a4b919acf2481dd2963f1603b-pie_slice_order.png";